<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">身份认证</span>
            <span v-if="isUpdate" class="save" @click="update">上传</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div v-if="isUpdate">
                <div class="imgBox">
                    <div class="icon"></div>
                </div>
                <div class="button">
                    <button>从相册选一张</button>
                    <button>拍一张照片</button>
                </div>
            </div>
            <div v-else class="minContent">
                <div class="tip">请上传身份证照
                    <img src="../../assets/images/colock.png" alt="">
                </div>
                <div class="idIcon1">
                    <div class="idImg">
                        <img @click="clickUpdate" src="../../assets/images/idIcon.png" alt=""><br>
                        <div class="tip1">身份证正面照</div>
                    </div>
                </div>
                <div class="idIcon1">
                    <div class="idImg">
                        <img @click="clickUpdate" src="../../assets/images/idIcon.png" alt=""><br>
                        <div class="tip1">身份证反面照</div>
                    </div>
                </div>
                <div class="personInfo">
                    <ul>
                        <li>
                            <div class="item">
                                <span>姓名</span>
                                <input type="text" placeholder="请输入姓名" maxlength="10">
                            </div>
                        </li>
                        <li>
                            <div class="item">
                                <span>身份证号</span>
                                <input type="text" placeholder="请输入身份证号" maxlength="18">
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="button commit">
                    <button>确认并提交</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Navbar, TabItem,Switch,Actionsheet } from 'mint-ui';
export default {
  data() {
    return {  
        isUpdate:false,
    };
  },
  computed: {},
  components: {},
  methods: {
      //上传身份证
      update(){
          this.isUpdate = false;
      },
      //提交身份证信息
      commitId(){

      },
      //点击上传
      clickUpdate(){
          this.isUpdate = true;
      }
  },
  mounted(){
        
    },           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 35%;
  transform: translateY(-50%);
}
.save {
  font-size: 0.42rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 88%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  /* overflow-x: hidden; */
  overflow: hidden;
}
.imgBox{
    width: 100%;
    height: 6.55rem;
    background-color: rgba(229,229,229,1);
    position: relative;
    top: 0.16rem;
}
.icon{
    width: 8.71rem;
    height: 4.97rem;
    border: 0.03rem solid rgba(245, 245, 245, 1);
    text-align: center;
    border-radius: 0.13rem;
    line-height: 0.53rem;
    position: absolute;
    top: 0.39rem;
    left: 0.58rem;

}
.button{
    height: 5.97rem;
    width: 100%;
    text-align: center;
    position: relative;
    top: 5.63rem;
}
.button button{
    width: 6.58rem;
    height: 1.18rem;
    margin-top: 0.68rem;
    border-radius: 0.16rem;
    background-color: rgba(41, 158, 173, 1);
    text-align: center;
    font-size: 0.42rem;
    color: #fff;
}
.tip{
    text-align: center;
    font-size: 0.37rem;
    line-height: 0.53rem;
    color: rgba(0, 0, 0, 0.7);
}
.tip img{
    width: 0.53rem;
    height: 0.53rem;
}
.idIcon1{
    width: 8.68rem;
    height: 5rem;
    background-color: #fff;
    text-align: center;
    margin-left: 0.61rem;
    margin-top: 0.18rem;
    border: 0.03rem solid rgba(187, 187, 187, 1);
}
.idImg{
    padding-top: 1.82rem;
}
.idImg img{
    width: 1.05rem;
    height: 1.05rem;
}
.tip1{
    margin-top: 0.53rem;
    font-size: 0.37rem;
    line-height: 0.53rem;
    color: rgba(0, 0, 0, 0.7);
}
.personInfo{
    background-color: #fff;
    margin-top: 0.71rem;
}
.item{
    height: 0.7rem;
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.7);
    margin-left: 0.53rem;
    line-height: 0.53rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0, 0.1);
    padding-top: 0.23rem;
    position: relative;
}
.item input{
    width: 4.39rem;
    height: 0.66rem;
    border: none;
    position: absolute;
    top: 0.13rem;
    right: 2.24rem;
}
.commit{
    position: relative;
    top: 0rem;
}
</style>




// WEBPACK FOOTER //
// src/components/mine/identity.vue